import { ArrowLeft, Radio, Search } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import ChannelsList from "../components/ChannelsList";
import { CircularProgress } from "@mui/material";
import apiClient from "../utils/apiClient";
import { useEffect } from "react";

export default function SportsChannels() {
    const [search, setSearch] = useState("");
    const [events, setEvents] = useState([]);

    const [loadingEvents, setLoadingEvents] = useState(false);

    const getEvents = async () => {
        try {
            setLoadingEvents(true);

            const response = await apiClient.get('/public/channel')
            const result = await response?.data;

            if (result?.success) {
                setEvents(result.data);
            }

        } catch (error) {
            console.log("Country API Error:", error);
        } finally {
            setLoadingEvents(false);
        }
    };

    useEffect(() => {
        getEvents();
    }, []);


    if (loadingEvents) {
        return (
            <div className="flex justify-center py-6">
                <CircularProgress size={24} />
            </div>
        )
    }

    const filteredChannels = events.filter(
    (item) => {

        const searchText =
            search?.toLowerCase()?.trim();

        const channelName =
            item?.channel_name
                ?.toLowerCase() || "";

        const shortTitle =
            item?.short_title
                ?.toLowerCase() || "";

        return (
            channelName.includes(searchText) ||
            shortTitle.includes(searchText)
        );
    }
);

    return (
        <main className="flex-1 container mx-auto px-4 py-6">

            {/* Header */}
            <div className="flex items-center gap-4 mb-6">

                {/* Back Button */}
                <Link
                    to="/"
                    className="
            p-2
            rounded-xl
            border
            border-gray-200
            dark:border-gray-700
            bg-white
            dark:bg-gray-900
            hover:border-blue-500
            transition-colors
            shadow-sm
          "
                >
                    <ArrowLeft className="w-5 h-5 text-gray-700 dark:text-gray-300" />
                </Link>

                {/* Title */}
                <div className="flex items-center gap-3">

                    <div
                        className="
              p-2
              rounded-xl
              bg-gradient-to-br
              from-blue-500/20
              to-purple-500/20
              border
              border-blue-500/20
            "
                    >
                        <Radio className="w-5 h-5 text-blue-500" />
                    </div>

                    <h1
                        className="
              text-2xl
              md:text-3xl
              font-bold
              bg-gradient-to-r
              from-blue-500
              to-purple-500
              bg-clip-text
              text-transparent
            "
                    >
                        All Sports Channels
                    </h1>

                </div>
            </div>

            {/* Search */}
            <div className="relative mb-6 max-w-md">

                <Search
                    className="
            absolute
            left-3
            top-1/2
            -translate-y-1/2
            w-4
            h-4
            text-gray-400
          "
                />

                <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search channels..."
                    className="
            w-full
            h-11
            rounded-xl
            border
            border-gray-200
            dark:border-gray-700
            bg-gray-100/70
            dark:bg-gray-800/50
            pl-10
            pr-4
            px-4
            text-sm
            text-gray-900
            dark:text-white
            placeholder:text-gray-500
            dark:placeholder:text-gray-400
            focus:outline-none
            focus:ring-2
            focus:ring-blue-500
            focus:border-blue-500
            transition-all
            backdrop-blur
          "
                />
            </div>
            {
                filteredChannels?.length > 0 ? (
                    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2">
                        <ChannelsList channels={filteredChannels} />
                    </div>
                ) : (
                    <div className="w-full py-10 flex items-center justify-center">
                        <h2 className="text-lg font-semibold text-gray-500">
                            No Channels Found
                        </h2>
                    </div>
                )
            }
        </main>
    );
}